import crudHandlers from './_crud'

const initialState = {
	chefs: []
	// personalById: null,
}
export default (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case 'LOAD_CHEFS':
			return { ...state, chefs: payload }
		default:
			// state = crudHandlers(state, action, 'waiters')

			return state
	}
}
